import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import Notifications from "vue-notification";
import VueCookies from "vue-cookies";
import VueSweetalert2 from "vue-sweetalert2";
import Print from "vue-print-nb";
import cookies from "vue-cookies";

import "./registerServiceWorker";
import "@fortawesome/fontawesome-free/css/all.min.css";

import BootstrapVue from "bootstrap-vue";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";

import "sweetalert2/dist/sweetalert2.min.css";

Vue.use(Notifications);
Vue.use(BootstrapVue);
Vue.use(VueCookies);
Vue.use(cookies);

const moment = require("moment");
require("moment/locale/uk");
Vue.use(require("vue-moment"), { moment });

Vue.use(VueSweetalert2);
Vue.use(Print);

Vue.config.productionTip = false;
Vue.config.performance = true;

import JsonRpcVueClient from "vue-json-rpc-client-fetch-withcredentials";
let rpcURP = process.env.NODE_ENV === "development" ? "/api" : "/api";
Vue.use(JsonRpcVueClient, rpcURP);

import useRpc from "./common/mixins";
import showNtf from "./common/mixins";
Vue.mixin(useRpc);
Vue.mixin(showNtf);

router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
  const token_my = to.query.token;

  if (token_my) {
    Vue.$cookies.set("user-token", token_my, "1d");
  }
  const token = Vue.$cookies.isKey("user-token") || !!token_my;
  if (to.path === '/') {
    next({ path: token ? '/profile/home' : '/login', replace: true });
    return;
  }

  
  if (requiresAuth) {
    token ? next() : next("/login");
  } else {
    next();
  }
});


Vue.filter("prettyBytes", function(num) {
  if (typeof num !== "number" || isNaN(num)) {
    throw new TypeError("Expected a number");
  }

  var exponent;
  var unit;
  var neg = num < 0;
  var units = ["B", "kB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

  if (neg) {
    num = -num;
  }

  if (num < 1) {
    return (neg ? "-" : "") + num + " B";
  }

  exponent = Math.min(
    Math.floor(Math.log(num) / Math.log(1000)),
    units.length - 1
  );
  num = (num / Math.pow(1000, exponent)).toFixed(2) * 1;
  unit = units[exponent];

  return (neg ? "-" : "") + num + " " + unit;
});

new Vue({
  router,
  store,
  el: "#app",
  data() {
    return {
      notificationSystem: {
        options: {
          show: {
            theme: "dark",
            icon: "icon-person",
            position: "topCenter",
            progressBarColor: "rgb(0, 255, 184)"
          },
          ballon: {
            balloon: true,
            position: "bottomCenter"
          },
          info: {
            position: "bottomLeft"
          },
          success: {
            position: "bottomRight"
          },
          warning: {
            position: "topLeft"
          },
          error: {
            position: "topRight"
          }
        }
      }
    };
  },
  render(createElement) {
    return createElement(App);
  }
});
